










































































































































































































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper"
import { DateHelper } from "@/helper/dateHelper"
import { ColorConstruct } from "@/utilityModels/colorConstruct"
import { UserConfigColors } from "@/userConfigColors/userConfigColors"

import CheckBoxOn from "../../resources/checkBoxOn.vue"
import ArrowDown from "../../resources/arrowDown.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import { Const } from "@/const";

@Component({
  components: {
    CheckBoxOn,
    ArrowDown,
    ColorSelector,
    ColorPicker,
    DropdownList
  }
})
export default class colorSkin extends Vue {

  theme = 0;
  isThemeDropdownVisible = false;
  get buildVersion() { return "build: " + Const.BUILD_VERSION; }

  private get themeDropdownItems() {
        var items = new Array();
        items.push({
            id: 0,
            isSelected: this.theme == 0,
            label: "ラベル屋さんカラー(グリーン)"
        });
        items.push({
            id: 1,
            isSelected: this.theme == 1,
            label: "シンプル（グレー）"
        });
        items.push({
            id: 2,
            isSelected: this.theme == 2,
            label: "チョコ（茶）"
        });
        items.push({
            id: 3,
            isSelected: this.theme == 3,
            label: "クール（青）"
        });
        items.push({
            id: 4,
            isSelected: this.theme == 4,
            label: "エレガント（赤）"
        });
           
        return items;
    }

  setTheme(theme){
      this.theme = theme;
      if(theme == 0){
          this.onChangedColor({ r : 41 , g : 179 , b : 91 } , "controlColor");
          this.onChangedColor({ r : 255 , g : 255 , b : 255 } , "backgroundColor");
          this.onChangedColor({ r : 6 , g : 49 , b : 22 } , "textAColor");
          this.onChangedColor({ r : 1 , g : 98 , b : 36 } , "textBColor");
      }
      else if(theme == 1){
          this.onChangedColor({ r : 111 , g : 111 , b : 111 } , "controlColor");
          this.onChangedColor({ r : 240 , g : 240 , b : 240 } , "backgroundColor");
          this.onChangedColor({ r : 74 , g : 74 , b : 74 } , "textAColor");
          this.onChangedColor({ r : 111 , g : 111 , b : 111 } , "textBColor");
      }
      else if(theme == 2){
          this.onChangedColor({ r : 116 , g : 74 , b : 60 } , "controlColor");
          this.onChangedColor({ r : 202 , g : 193 , b : 178 } , "backgroundColor");
          this.onChangedColor({ r : 74 , g : 74 , b : 74 } , "textAColor");
          this.onChangedColor({ r : 86 , g : 72 , b : 63 } , "textBColor");
      }
      else if(theme == 3){
          this.onChangedColor({ r : 70 , g : 110 , b : 168 } , "controlColor");
          this.onChangedColor({ r : 215 , g : 230 , b : 238 } , "backgroundColor");
          this.onChangedColor({ r : 74 , g : 74 , b : 74 } , "textAColor");
          this.onChangedColor({ r : 70 , g : 110 , b : 168 } , "textBColor");
      }
      else if(theme == 4){
          this.onChangedColor({ r : 181 , g : 15 , b : 47 } , "controlColor");
          this.onChangedColor({ r : 255 , g : 255 , b : 31 } , "backgroundColor");
          this.onChangedColor({ r : 74 , g : 74 , b : 74 } , "textAColor");
          this.onChangedColor({ r : 119 , g : 0 , b : 0 } , "textBColor");
      }
      this.isThemeDropdownVisible = false;
  }

  isControlColorPickerVisible = false;
  isBackgroundColorPickerVisible = false;
  isTextAColorPickerVisible = false;
  isTextBColorPickerVisible = false;

  controlColor = { r : 0 , g : 0 , b : 0 };
  backgroundColor = { r : 0 , g : 0 , b : 0 };
  textAColor = { r : 0 , g : 0 , b : 0 };
  textBColor = { r : 0 , g : 0 , b : 0 };

  mounted(){
    //参照渡し回避
    this.controlColor.r = this.userConfigColors.colors.controlColor.r;
    this.controlColor.g = this.userConfigColors.colors.controlColor.g;
    this.controlColor.b = this.userConfigColors.colors.controlColor.b;
    this.backgroundColor.r = this.userConfigColors.colors.backgroundColor.r;
    this.backgroundColor.g = this.userConfigColors.colors.backgroundColor.g;
    this.backgroundColor.b = this.userConfigColors.colors.backgroundColor.b;
    this.textAColor.r = this.userConfigColors.colors.textAColor.r;
    this.textAColor.g = this.userConfigColors.colors.textAColor.g;
    this.textAColor.b = this.userConfigColors.colors.textAColor.b;
    this.textBColor.r = this.userConfigColors.colors.textBColor.r;
    this.textBColor.g = this.userConfigColors.colors.textBColor.g;
    this.textBColor.b = this.userConfigColors.colors.textBColor.b;
    
    this.theme = CookieHelper.hasItem("theme") ? CookieHelper.getItem("theme") : 0;
  }

  get controlColorConstruct() : ColorConstruct{
    return new ColorConstruct(this.controlColor.r,this.controlColor.g,this.controlColor.b);
  }

  get backgroundColorConstruct() : ColorConstruct{
    return new ColorConstruct(this.backgroundColor.r,this.backgroundColor.g,this.backgroundColor.b);
  }

  get textAColorConstruct() : ColorConstruct{
    return new ColorConstruct(this.textAColor.r,this.textAColor.g,this.textAColor.b);
  }

  get textBColorConstruct() : ColorConstruct{
    return new ColorConstruct(this.textBColor.r,this.textBColor.g,this.textBColor.b);
  }

  saveCookie(){

    var colorSkin = {
      "controlColor" : this.controlColor,
      "backgroundColor" : this.backgroundColor,
      "textAColor" : this.textAColor,
      "textBColor" : this.textBColor
    };

    CookieHelper.setItem("colorSkin" , colorSkin);
    CookieHelper.setItem("theme" , this.theme);
  }

  private onOk() {
    this.saveCookie();
    this.$store.getters.userConfigColors.update();
    this.$emit("close");
  }

  
  // 色変更中
  private onChangingColor(color : ColorConstruct , tag : string) 
  {

    if(tag == "controlColor"){
      this.controlColor.r = color.r;
      this.controlColor.g = color.g;
      this.controlColor.b = color.b;
    }

    if(tag == "backgroundColor"){
      this.backgroundColor.r = color.r;
      this.backgroundColor.g = color.g;
      this.backgroundColor.b = color.b;
    }

    if(tag == "textAColor"){
      this.textAColor.r = color.r;
      this.textAColor.g = color.g;
      this.textAColor.b = color.b;
    }

    if(tag == "textBColor"){
      this.textBColor.r = color.r;
      this.textBColor.g = color.g;
      this.textBColor.b = color.b;
    }
     
  }
  // 色変更完了
  private onChangedColor(color , tag) 
  {
    if(tag == "controlColor"){
      this.controlColor.r = color.r;
      this.controlColor.g = color.g;
      this.controlColor.b = color.b;
    }

    if(tag == "backgroundColor"){
      this.backgroundColor.r = color.r;
      this.backgroundColor.g = color.g;
      this.backgroundColor.b = color.b;
    }
    if(tag == "textAColor"){
      this.textAColor.r = color.r;
      this.textAColor.g = color.g;
      this.textAColor.b = color.b;
    }

    if(tag == "textBColor"){
      this.textBColor.r = color.r;
      this.textBColor.g = color.g;
      this.textBColor.b = color.b;
    }
  }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
    

}
